export const catChuoi = (value, quantity) => {
  if (value && value.length > quantity)
    return value.substring(1, quantity) + "...";
  else return value;
};
export const catChuoi1 = (value, quantity) => {
  if (value && value.length > quantity)
    return value.substring(0, quantity) + "...";
  else return value;
};